import {override} from "mobx";
import {ACTION_TYPES} from "../../../../../core/consts";
import {ANALYTICS} from "../../../../../third-party-services/analytics/analytics-consts";
import {GameCenterTabModel} from "./game-center.tab-model";
import {APP} from "../../../../../core/app/consts";

export class GameCenterStatsTabModel extends GameCenterTabModel {
  @override get isVisible(): Boolean {
    return this.entity.hasStats;
  }

  get eventName(): String {
    return ACTION_TYPES.statsClick
  }

  get eventParams(): Object {
    const eventParams = {
      gameId: this.entity.id,
      entityId: this.entity.id,
      status: ANALYTICS.GAME_STATUSES[this.entity.statusGroup],
      source: APP.ANALYTICS.SOURCES.gameCenterTabs,
      entityType: ANALYTICS.ENTITY_TYPES.game,
    }

    return eventParams;
  }

  get analyticsName(): Object {
    return ANALYTICS.TAB_NAMES.stats;
  }

  get elementId(): String {
    return 'navigation-tabs_game-center_stats';
  }
}
